const conf = {
  logo: require('./assets/logo.png'),
  system: '盛景和',
  company: '河北盛景和医药科技有限公司'
}

export default conf
